// extracted by mini-css-extract-plugin
module.exports = {"controls":"styles_controls__ES5ww","progressBar":"styles_progressBar__1ScAP"};